import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface EventInfoImage {
	imageNm: string;
	imageNote: string;
	imageThum1: string;
	imageThum2: string;
	imageThum3: string;
	imageThum4: string;
	sortOrder: number;
}

/** ```
 * 행사 정보 이미지 조회
 *   `/pkg/event-info/{infoId}/{type}/images`
 * parameter
 *   `infoId` 관광지정보ID
 *   `type` 타입 ( "travel" | "hotel") default : travel
 *   `evCd?` 이벤트코드 (type === "hotel" 일경우 필요)
 * ```*/
const key = "useEventInfoImages";
const getPath = (infoId: string, type?: "travel" | "hotel", evCd?: string): string | null => {
	if (!infoId) return null;
	if (type === "hotel" && evCd)
		return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/event-info/${infoId}/${evCd}/${type || "travel"}/images`;
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/event-info/${infoId}/${type || "travel"}/images`;
};

/** ```
 * 행사 정보 이미지 조회
 *   `/pkg/event-info/{infoId}/{type}/images`
 * parameter
 *   `infoId` 관광지정보ID
 *   `type` 타입 ( "travel" | "hotel") default : travel
 *   `evCd?` 이벤트코드 (type === "hotel" 일경우 필요)
 * ```*/
const useEventInfoImages = (
	infoId: string,
	type?: "travel" | "hotel",
	evCd?: string,
	options?: Partial<UseQueryOptions<Response<EventInfoImage[]>, Error>>,
) =>
	useQuery({
		queryKey: [key, getPath(infoId, type, evCd)],
		queryFn: () => useConfigureAxios({url: getPath(infoId, type, evCd)}).then(r => r.data),
		staleTime: 1000 * 30 * 60,
		...options,
	});

export default useEventInfoImages;
export {getPath};
export type {EventInfoImage};
